export const emailAsArray = (value: string): string[] => {
  const emails = value
    .split(',')
    .map((email) => email.trim())
    .filter((email) => !!email);
  const unique = new Set(emails);
  return Array.from(unique);
};
